import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38345dee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=38345dee&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/newPagination.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38345dee",
  null
  
)

export default component.exports